import { render, staticRenderFns } from "./head_modules.vue?vue&type=template&id=5347e45e&scoped=true"
import script from "./head_modules.vue?vue&type=script&lang=js"
export * from "./head_modules.vue?vue&type=script&lang=js"
import style0 from "./head_modules.vue?vue&type=style&index=0&id=5347e45e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5347e45e",
  null
  
)

export default component.exports